import { inject } from '@angular/core';
import { filter, first, Observable } from 'rxjs';

import { BrandingService } from '@ideals/services/branding';
import { IRoomLoginInfo } from '@ideals/types';

export function roomLoginInfoResolver(): Observable<IRoomLoginInfo> {
  return inject(BrandingService).logotypeWithRoomName$
    .pipe(
      filter(Boolean),
      first(),
    );
}
